// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"style_modalFooter__1iqVt"};